import Cookies from 'js-cookie';
import RewardsService from 'services/Spring/RewardsService';
import { HttpServiceSpring } from 'services/Spring/client/types';
import RaceService from 'services/Spring/RaceService';
import UserService from 'services/Spring/UserService';
import { LocalStorageKeys } from 'appConstants/LocalStorageKeys';
import { createHttpInstance, HttpRequestConfig } from 'services/httpClient';

const API_URL = import.meta.env.VITE_DEV_SPRING;

export const instanceSpring = createHttpInstance({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

instanceSpring.interceptors.request.use((config: HttpRequestConfig) => {
  // todo change to JWT
  const token = Cookies.get(LocalStorageKeys.TOKEN_KEY);
  if (token) {
    const headers = { ...(config.headers ?? {}) };
    headers.Authorization = `Bearer ${JSON.parse(token)}`;
    return { ...config, headers };
  }
  return config;
});

export const httpServiceSpring: HttpServiceSpring = {
  RewardsService,
  RaceService,
  UserService,
};
